import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06523e94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1))
const _hoisted_3 = { class: "rearrange" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "column-section" }
const _hoisted_7 = { class: "media-position" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Media Position", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Column Media", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Header", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1))
const _hoisted_14 = { class: "d-flex flex-wrap" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0" }, "Menu Items", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "float-end",
        onClick: _ctx.clearMenusHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode("Clear Menus")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          prop: "backgroundColor",
          label: "Background Color"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_color_picker, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.background,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.background) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (colNum, index) => {
        return _createElementVNode("section", {
          class: "signage__column",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "Move up",
              placement: "top"
            }, {
              default: _withCtx(() => [
                (index != 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: ($event: any) => (_ctx.moveListUp(colNum, index+1)),
                      size: "small",
                      circle: "",
                      class: "ghost m-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          class: "dt-icon--large",
                          icon: _ctx.mdiArrowUpBold
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4))
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "Move down",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                (index != 2)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: ($event: any) => (_ctx.moveListDown(colNum, index+1)),
                      size: "small",
                      circle: "",
                      class: "ghost m-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          class: "dt-icon--large",
                          icon: _ctx.mdiArrowDownBold
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5))
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.signageItemLayoutData[`column${colNum}`].mediaPosition = 'TOP'),
                size: "small",
                class: _normalizeClass(["media-position_button", { 'media-position_button--active' : _ctx.signageItemLayoutData[`column${colNum}`].mediaPosition == 'TOP' }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Top")
                ]),
                _: 2
              }, 1032, ["onClick", "class"]),
              _hoisted_9,
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.signageItemLayoutData[`column${colNum}`].mediaPosition = 'BOTTOM'),
                size: "small",
                class: _normalizeClass(["media-position_button", { 'media-position_button--active' : _ctx.signageItemLayoutData[`column${colNum}`].mediaPosition == 'BOTTOM' }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Bottom")
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ]),
            _createElementVNode("h1", _hoisted_10, "Column " + _toDisplayString(index + 1), 1),
            _hoisted_11,
            _createVNode(_component_DigitalAssetUpload, {
              class: "my-4",
              allowVideo: "true",
              sizeLimitMB: "300",
              layoutProperty: _ctx.getLayoutProperty(index),
              layoutType: _ctx.layoutType,
              assetUrl: _ctx.assetUrl[index]
            }, null, 8, ["layoutProperty", "layoutType", "assetUrl"]),
            _hoisted_12,
            _createVNode(_component_el_form_item, {
              class: "col-lg-6",
              prop: "headerText"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.signageItemLayoutData[`column${colNum}`].headerText,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData[`column${colNum}`].headerText) = $event),
                  placeholder: "Header"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_form_item, {
                class: "me-4",
                prop: "headerFontColor",
                label: "Header Font Color"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_color_picker, {
                    class: "mt-1",
                    modelValue: _ctx.signageItemLayoutData[`column${colNum}`].headerFontColor,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData[`column${colNum}`].headerFontColor) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_form_item, {
                class: "me-4",
                prop: "headerColor",
                label: "Header Color"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_color_picker, {
                    class: "mt-1",
                    modelValue: _ctx.signageItemLayoutData[`column${colNum}`].headerColor,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData[`column${colNum}`].headerColor) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_form_item, {
                prop: "fontColor",
                label: "Font Color"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_color_picker, {
                    class: "mt-1",
                    modelValue: _ctx.signageItemLayoutData[`column${colNum}`].fontColor,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData[`column${colNum}`].fontColor) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024)
            ]),
            _hoisted_15,
            _createVNode(_component_draggable, {
              class: "p-0 m-0",
              handle: ".drag",
              modelValue: _ctx.signageItemLayoutData[`column${colNum}`].menu,
              "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData[`column${colNum}`].menu) = $event),
              tag: "ul",
              "item-key": "id"
            }, {
              item: _withCtx(({ element, index }) => [
                _createElementVNode("li", {
                  class: _normalizeClass(["d-flex align-items-center", { 'mb-2': index < _ctx.signageItemLayoutData[`column${colNum}`].menu.length }])
                }, [
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "Reorder",
                    placement: "bottom",
                    "hide-after": 0,
                    "show-after": 500
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        class: "me-2 drag",
                        icon: _ctx.mdiDragHorizontalVariant
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "flex-grow-1 m-0 me-2",
                    prop: "menuTitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: element.title,
                        "onUpdate:modelValue": ($event: any) => ((element.title) = $event),
                        placeholder: "Title"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, {
                    class: "flex-grow-1 m-0 me-2",
                    prop: "menuDescription"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: element.description,
                        "onUpdate:modelValue": ($event: any) => ((element.description) = $event),
                        placeholder: "Description"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, {
                    class: "flex-grow-1 m-0 me-2",
                    prop: "menuPrice"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: element.price,
                        "onUpdate:modelValue": ($event: any) => ((element.price) = $event),
                        placeholder: "Price"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "Duplicate",
                    placement: "bottom",
                    "hide-after": 0,
                    "show-after": 500
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.signageItemLayoutData[`column${colNum}`].menu.splice(index, 0 , {...element})),
                        type: "button",
                        class: "dt-icon-button"
                      }, [
                        _createVNode(_component_Icon, { icon: _ctx.mdiContentDuplicate }, null, 8, ["icon"])
                      ], 8, _hoisted_16)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "Delete",
                    placement: "bottom",
                    "hide-after": 0,
                    "show-after": 500
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.signageItemLayoutData[`column${colNum}`].menu.splice(index, 1)),
                        class: "dt-icon-button"
                      }, [
                        _createVNode(_component_Icon, { icon: _ctx.mdiClose }, null, 8, ["icon"])
                      ], 8, _hoisted_17)
                    ]),
                    _: 2
                  }, 1024)
                ], 2)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_button, {
              class: "mt-2",
              type: "primary",
              plain: "",
              onClick: ($event: any) => (_ctx.signageItemLayoutData[`column${colNum}`].menu.push({ title: '', description: '', price: '' }))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Menu Item")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ])
      }), 64))
    ]),
    _: 1
  }, 8, ["model"]))
}